import {Component, computed, inject} from '@angular/core';
import {DecimalPipe, NgOptimizedImage} from '@angular/common';
import {StoreConfigService} from '@core/services/store-config.service';
import {environment} from '@env/environment';

@Component({
  selector: 'app-footer-bottom',
  templateUrl: './footer-bottom.component.html',
  styleUrl: './footer-bottom.component.scss',
  imports: [
    NgOptimizedImage,
    DecimalPipe
  ]
})
export class FooterBottomComponent {
  private storeConfigService = inject(StoreConfigService);

  showDanishVersion = environment.locale === 'da-DK';
  showSwedishVersion = environment.locale === 'sv-SE';

  freeDeliveryStartsFrom = computed(() => {
    return this.storeConfigService.storeConfig()?.freeDeliveryStartsFrom;
  });

  minimumFreightPrice = computed(() => {
    return this.storeConfigService.storeConfig()?.minimumFreightPrice;
  });
}
